import React from 'react'
import RowButton from 'components/atoms/row-button'
import SelectTableFilter from 'components/atoms/select-table-filter'
import {
  STATUS,
  COURIER,
  COURIER_SERVICE_TYPE
} from 'domains/customer-refund-shipment/constants'
import {
  CustomerRefundShipmentStatusBadge,
  CustomerRefundShipmentCourierBadge,
  CustomerRefundShipmentCourierServiceTypeBadge
} from 'domains/customer-refund-shipment/atoms'

const customerRefundShipmentTableColumns = ({
  handleClickDetail
}) => {

  // Custom Filter
  // Used to modify the filter in specific columns
  // eslint-disable-next-line react/prop-types
  const CourierFilter = ({ column }) => {
    const options = Object.keys(COURIER).map((key) => (
      {
        label : COURIER[key],
        value : COURIER[key]
      }
    ))
    return (
      <SelectTableFilter
        reactTableColumn={ column }
        options={ options }
      />
    )
  }

  // eslint-disable-next-line react/prop-types
  const CourierServiceTypeFilter = ({ column }) => {
    const options = Object.keys(COURIER_SERVICE_TYPE).map((key) => (
      {
        label : COURIER_SERVICE_TYPE[key],
        value : COURIER_SERVICE_TYPE[key]
      }
    ))
    return (
      <SelectTableFilter
        reactTableColumn={ column }
        options={ options }
      />
    )
  }

  // eslint-disable-next-line react/prop-types
  const StatusFilter = ({ column }) => {
    const options = Object.keys(STATUS).map((key) => (
      {
        label : STATUS[key],
        value : STATUS[key]
      }
    ))
    return (
      <SelectTableFilter
        reactTableColumn={ column }
        options={ options }
      />
    )
  }

  const StatusCell = (row) => <CustomerRefundShipmentStatusBadge status={ row.cell.value } />

  const CourierCell = (row) => <CustomerRefundShipmentCourierBadge courier={ row.cell.value } />

  const CourierServiceTypeCell = (row) => <CustomerRefundShipmentCourierServiceTypeBadge courier_service_type={ row.cell.value } />

  // eslint-disable-next-line react/prop-types
  const ActionCell = ({ cell: { row } }) => (
    <RowButton
      // eslint-disable-next-line react/prop-types
      data={ row.original }
      color={ 'primary' }
      onClick={ handleClickDetail }
      text={ 'detail' }
    />
  )

  return (
    [
      {
        Header   : 'Number',
        accessor : 'number'
      },
      {
        Header   : <>Recipient<br/>Name.</>,
        accessor : 'recipient_name'
      },

      {
        Header   : 'Status',
        accessor : 'status',
        Cell     : StatusCell,
        Filter   : StatusFilter
      },
      {
        Header   : 'Courier',
        accessor : 'courier',
        Cell     : CourierCell,
        Filter   : CourierFilter
      },
      {
        Header   : <>Courier<br/>Service Type</>,
        accessor : 'courier_service_type',
        Cell     : CourierServiceTypeCell,
        Filter   : CourierServiceTypeFilter
      },
      {
        Header : 'Action',
        id     : 'action',
        Cell   : ActionCell
      }
    ]
  )

}

export default customerRefundShipmentTableColumns
